import React from 'react'
import { XPKinshipRelationshipTypes } from 'utils/constants/DueDiligenceRelations'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayXPKinshipRelations(props) {
  const { questionData } = props
  const classes = styles()

  const buildKinshipRelation = (activityInfo) => {
    return (
      <div className={classes.answersContainer} key={activityInfo.key}>
        <p>
          <span>Nome completo do colaborador XP: </span>
          {activityInfo?.relative_name}
        </p>
        <p>
          <span>Cargo: </span>
          {activityInfo?.occupation}
        </p>

        <p>
          <span>Grau de parentesco: </span>
          {XPKinshipRelationshipTypes[activityInfo?.kinship_degree]}
        </p>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento dos parentescos com colaboradores XP Inc.:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não possui grau de parentesco com nenhum colaborador do grupo XP Inc."
        funcBuildItem={buildKinshipRelation}
      />
    </div>
  )
}

export default DisplayXPKinshipRelations
